function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { hideModal } from '../../redux/actions';
import text from '../../text';
export var JOB_FAILURE_MODAL = 'JOB_FAILURE_MODAL';
var JobFailureModal = function(props) {
    var dispatch = useDispatch();
    var onHide = function() {
        dispatch(hideModal(JOB_FAILURE_MODAL));
        props.onHide && props.onHide();
    };
    return /*#__PURE__*/ React.createElement(Modal, _object_spread_props(_object_spread({
        centered: true
    }, props), {
        onHide: onHide
    }), /*#__PURE__*/ React.createElement(Modal.Body, null, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h2", null, text('orderCouldNotSaved')), /*#__PURE__*/ React.createElement("p", {
        className: "text-center"
    }, text('orderCouldNotSavedAtTime')), /*#__PURE__*/ React.createElement("p", {
        className: "text-center"
    }, text('pleaseTryAgainApologise')), /*#__PURE__*/ React.createElement("div", {
        className: "form-footer"
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "button",
        className: "metromap-modal-button",
        onClick: onHide
    }, text('returnToMap'))))));
};
export default JobFailureModal;
